module.exports = __webpack_public_path__ + "img/App-icon.5137c281.svg";